import { gql } from 'graphql-request'
import { useMutation, UseMutationResult } from '@/proxy/react-query'

import { client } from '@/proxy/client'
import { MutationDataError } from '../../../../resources/types'
import {
  UseGetCustomerPhoneNumber,
  UseGetCustomerPhoneNumberInput,
} from './types'

export const SELLER_GET_CUSTOMER_PHONE_NUMBER = gql`
  mutation sellerGetCustomerPhoneNumber(
    $orderNumber: String!
    $contactReason: OrderContactReasonInput!
  ) {
    getCustomerPhoneNumber(
      orderNumber: $orderNumber
      contactReason: $contactReason
    ) {
      phoneNumber
    }
  }
`

export const useSellerGetCustomerPhoneNumber = (): UseMutationResult<
  UseGetCustomerPhoneNumber,
  MutationDataError,
  UseGetCustomerPhoneNumberInput
> =>
  useMutation({
    mutationFn: variables =>
      client.request(SELLER_GET_CUSTOMER_PHONE_NUMBER, variables),
  })
